import http from "../../../core/utils/apis/api";



const getAllRequests = async (page,take) => {
  try {
      const response = await http({
          method: 'GET',
          url: `/requests`,
          params: { 
            // search: searchQuery,
            take: take,
            page: page
        },
         
      });
      return response;
  } catch (e) {
      throw e;
  }
}

const getAllRequestsData = async (filterValues, page, take, searchQuery) => {
    try {
        const response = await http({
            method: 'POST',
            url: `/requests/allRequests`,
            params: { 
              search: searchQuery,
              take: take,
              page: page
          },
          data: filterValues,
        //   headers: {
        //     'Content-Type': 'multipart/form-data',
        //   },

           
        });
        return response;
    } catch (e) {
        throw e;
    }
  }
  const updateRequest = async (id, requestData) => {

    try {
      const response = await http({
        method: "PATCH",
        url: `/requests/${id}`,
        data: requestData,
      });
      return response;
    } catch (e) {
      throw e;
    }
  };




const trainingRequestsService = {

    getAllRequests,
    getAllRequestsData,
    updateRequest
    
};

export default trainingRequestsService;
